import { render, staticRenderFns } from "./activityOrdinary.vue?vue&type=template&id=596f7c5b&scoped=true&"
import script from "./activityOrdinary.vue?vue&type=script&lang=js&"
export * from "./activityOrdinary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f7c5b",
  null
  
)

export default component.exports